<template>
  <div class="drugs__filter">
    <label for="drug-filter">View by drug type</label>
    <div class="select">
      <select id="drug-filter" v-model="selectedFilter" @change="filterSelected">
        <option value="">All Drugs</option>
        <option v-for="type in drugTypes" :key="type.id" :value="type.name">
          {{ type.name }}
        </option>
      </select>
      <span class="icon icon--arrow"><arrow-svg></arrow-svg></span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ArrowSvg from '../svg/arrow.vue';

export default {
  name: 'drug-filter',
  components: { ArrowSvg },
  data() {
    return {
      drugTypes: [],
      selectedFilter: '',
    };
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_API_URL}drugtypes/`)
      .then((response) => {
        this.drugTypes = response.data.items;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.drugTypes = [];
        }
      });
  },
  methods: {
    /**
     * emit selected filter.
     */
    filterSelected() {
      this.$emit('filter-selected', this.selectedFilter);
    },
  },
};
</script>
